import React from "react";
import styles from "./ThankYouModal.module.scss";

interface ThankYouModalProps {
    status: string;
    couponCode?: string;
    onClose: () => void;
}

const ThankYouModal: React.FC<ThankYouModalProps> = ({ status, couponCode, onClose }) => {
    const renderContent = () => {
        switch (status) {
            case "consumer":
                return (
                    <>
                        <h1>Thank You!</h1>
                        <p>As a token of our appreciation, here is your 15% discount code.</p>
                        <div className={styles.couponCode}>{couponCode}</div>
                        <a href={`https://naarofficial.com/?discount=${couponCode}`} className={styles.shopButton}>
                            Shop Now & Apply Discount
                        </a>
                        <p className={styles.finePrint}>
                            This code is valid for 48 hours and can be used once.
                            <br />
                            Click the button above to automatically apply it to your cart.
                        </p>
                    </>
                );
            case "eligible":
            case "ineligible":
            default:
                return (
                    <>
                        <h1>Thank You!</h1>
                        <p>Thank you for your submission. We'll be in touch soon.</p>
                    </>
                );
        }
    };

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <button onClick={onClose} className={styles.closeButton}>
                    &times;
                </button>
                <div className={styles.content}>{renderContent()}</div>
            </div>
        </div>
    );
};

export default ThankYouModal;
